import type { KeyEventType, MouseEventType } from "../types";
import { createProxies } from "./proxies";

export type AxureMouseEventHandler = (hostId: string, eventType: MouseEventType, x: number, y: number, z: number, button: number, timestamp: number, modifiers: number) => boolean;
export type AxureMouseDoubleClickEventHandler = (hostId: string, x: number, y: number, timestamp: number, modifiers: number) => boolean;
export type AxureKeyEventHandler = (hostId: string, eventType: KeyEventType, code: string, timestamp: number, modifiers: number) => Promise<boolean>;
export type AxureWheelEventHandler = (hostId: string, x: number, y: number, dx: number, dy: number, dZ: number, dMode: number, timestamp: number, modifiers: number) => boolean;
export type AxurePinchZoomEventHandler = (hostId: string, x: number, y: number, dx: number, dy: number, zoom: number, timestamp: number) => boolean;
export type AxureUiEventHandler = (hostId: string) => boolean;
export type AxureUiEventHandlerAsync = (hostId: string) => Promise<boolean>;
export type AxureDropEventHandlerAsync = (hostId: string, x: number, y: number) => Promise<boolean>;

interface HostingExportsMethods {
  MouseEvent: AxureMouseEventHandler;
  MouseDoubleClickEvent: AxureMouseDoubleClickEventHandler;
  KeyEvent: AxureKeyEventHandler;
  WheelEvent: AxureWheelEventHandler;
  PinchZoomEvent: AxurePinchZoomEventHandler;
  ResizeEvent: AxureUiEventHandler;
  PasteEvent: AxureUiEventHandlerAsync;
  DropEvent: AxureDropEventHandlerAsync;
  CopyEvent: AxureUiEventHandlerAsync;
  CutEvent: AxureUiEventHandlerAsync;
  SetDebug: (debugText: string) => void;
}

export interface HostingExports {
  Hosting: HostingExportsMethods;
}

export const {
  setup,
  mouseEvent,
  mouseDoubleClickEvent,
  keyEvent,
  wheelEvent,
  pinchZoomEvent,
  resizeEvent,
  pasteEvent,
  dropEvent,
  copyEvent,
  cutEvent,
  setDebug,
} = createProxies<HostingExportsMethods>([
  "MouseEvent",
  "MouseDoubleClickEvent",
  "KeyEvent",
  "WheelEvent",
  "PinchZoomEvent",
  "ResizeEvent",
  "PasteEvent",
  "DropEvent",
  "CopyEvent",
  "CutEvent",
  "SetDebug",
]);
